import { render, staticRenderFns } from "./UnsubscribesFragmentConfirm.vue?vue&type=template&id=58883e08&scoped=true&"
import script from "./UnsubscribesFragmentConfirm.vue?vue&type=script&lang=js&"
export * from "./UnsubscribesFragmentConfirm.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscribesFragmentConfirm.vue?vue&type=style&index=0&id=58883e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58883e08",
  null
  
)

export default component.exports